import { useRef } from "react";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { isTabbyPromoUrl } from "@/utils/tabby";

function TabbyModal({ src, setShow }) {
  const tabbyRef = useRef(null);
  useOnClickOutside([tabbyRef], () => setShow(false));

  if (!isTabbyPromoUrl(src)) return null;

  return (
    <div className="fixed z-[3000] top-0 left-0 w-screen h-screen bg-black/60 max-h-screen overflow-y-auto flex items-center justify-center">
      <div ref={tabbyRef} className="relative w-[440px] max-[440px]:w-full">
        <iframe
          src={src}
          width="100%"
          height="600px"
          title="Tabby Checkout"
          className="rounded-[32px]"
        />
      </div>
    </div>
  );
}

export default TabbyModal;
